import React from 'react';
import { observer } from 'mobx-react';
import { AppUI } from '@seedlang/state';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class SiteCreate extends React.Component {

  onCreate = title => {
    const data = {
      siteId: AppUI.user.site.id,
      title: title,
    };

    AppUI.downloadLinkTypeStore.create({ data: data }, this.props.afterCreate);
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a Download Link Title'
        onCreate={this.onCreate}
      />
    );
  }
}

export default SiteCreate;
